import React from "react";
import { TabIcon, HeaderItem, SeparatorWrapper } from "../styles";

const HeaderItemWrapper = (props) => {
  const { active, icon, onClick, value } = props;

  const handleClick = () => {
    onClick(value);
  };

  return (
    <SeparatorWrapper>
      <HeaderItem active={active} onClick={handleClick}>
        <TabIcon src={icon} />
        <p>{value}</p>
      </HeaderItem>
    </SeparatorWrapper>
  );
};

export default HeaderItemWrapper;
